import Paper from '@material-ui/core/Paper';
import Container from '@material-ui/core/Container';
import PrivateLayout from '../../../../layouts/private';
import OrderForm from './form';

export default function OrdersEditScreen(props) {

    const recordId = +(props.match?.params?.id || 0);

    return (
        <PrivateLayout screenTitle="Edit Existing Order" screenPath="content.orders.update">
            <Paper elevation={2} style={{ paddingTop: 24, paddingBottom: 24, marginBottom: 14 }}>
                <Container>

                    <OrderForm isEdit recordId={recordId} />

                </Container>
            </Paper>
        </PrivateLayout>
    );
}
